import messages from 'messages';
import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import styles from './addMember.module.scss';
import ModalLayout from 'components/modal/modal-layout/ModalLayout';
import addTeamMember from 'services/team/addTeamMember';
import { useTeamContext } from 'contexts/group-practice-context/TeamContext';
import getRolesForTeam from 'services/team/getRoles';
import addRoles from 'services/team/addRoles';

const AddNewMember = ({
  showAddMemberModal,
  handleClose,
  setSuccessMsg,
  setError,
  error,
}) => {
  const { currentTeam } = useTeamContext();

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    role: '',
  });

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!currentTeam) {
      return;
    }
    try {
      const roles = await getRolesForTeam(currentTeam.id);
      const roleExists = roles.some(role => role.name === formData.role);
      if (!roleExists) {
        await addRoles(currentTeam.id, { role_name: formData.role });
      }
      await addTeamMember(currentTeam.id, formData);
      setSuccessMsg('Invite sent successfully');
      handleClose();
    } catch (err) {
      setError(err);
    }
  };

  return (
    <ModalLayout
      error={error}
      show={showAddMemberModal}
      onHide={handleClose}
      size='lg'
      showHeaderDivider
      Header={messages.addNewTeamMember}
      headerClass={styles['member-editor__header']}
      bodyClass={styles['member-editor__body']}
      footerClass={styles['member-editor__footer']}
      dialogClassName={styles['member-editor__dialog']}
    >
      <Modal.Body>
        <div className={styles['member-editor__section-header']}>
          {messages.memberInfo}
        </div>
        <Form onSubmit={handleSubmit}>
          <Row className='g-0'>
            <Form.Group
              as={Col}
              md='6'
              className={styles['member-editor__form-group-name']}
            >
              <Form.Label className={styles['member-editor__label']}>
                First Name <span className='required'>*</span>
              </Form.Label>
              <Form.Control
                required
                type='text'
                placeholder='Enter First Name'
                name='first_name'
                value={formData.first_name || ''}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group
              as={Col}
              md='6'
              className={styles['member-editor__form-group-name']}
            >
              <Form.Label className={styles['member-editor__label']}>
                Last Name <span className='required'>*</span>
              </Form.Label>
              <Form.Control
                required
                type='text'
                placeholder='Enter Last Name'
                name='last_name'
                value={formData.last_name || ''}
                onChange={handleChange}
              />
            </Form.Group>
          </Row>

          <Form.Group>
            <Form.Label className={styles['member-editor__label']}>
              Email Address <span className='required'>*</span>
            </Form.Label>
            <Form.Control
              required
              name='email'
              type='text'
              value={formData.email || ''}
              placeholder='Enter Email Address'
              onChange={handleChange}
              className={styles['member-editor__form-control']}
            />
          </Form.Group>

          <Form.Group controlId='formRole'>
            <Form.Label className={styles['member-editor__label']}>
              Role<span className='required'>*</span>
            </Form.Label>
            <Form.Control
              required
              as='select'
              name='role'
              value={formData.role}
              onChange={handleChange}
              className={styles['member-editor__form-control']}
            >
              <option value=''>Select a role</option>
              <option value='PRACTICE_SCHEDULER'>Practice Scheduler</option>
            </Form.Control>
          </Form.Group>

          <Modal.Footer>
            <Button variant='secondary' onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='primary' type='submit'>
              Add
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </ModalLayout>
  );
};

export default AddNewMember;
